import React from "react";
import "./DateSold.scss";
import { Box, Button, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import {
  ThemeProvider,
  createTheme,
  StyledEngineProvider,
} from "@mui/material/styles";
import HelpText, { getHelpText } from "../HelpText/HelpText";
import { getMaxDate, getMinDate } from "../../constants/dateFunctions";
import Grid from "@mui/material/Grid";
import TodayIcon from "@mui/icons-material/Today";

const theme = createTheme({
  typography: {
    fontFamily: "Proximanova Reg, sans-serif",
    button: {
      textTransform: "none",
      borderRadius: "5px",
    },
  },
  components: {
    // * current tab
    MuiTab: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            color: "white",
          },
        },
      },
    },
    // * controls styles for both tabs
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: "red",
          height: 3,
        },
      },
    },
    // * Displays the selected date
    MuiPickersToolbar: {
      styleOverrides: {
        root: {
          backgroundColor: "#3f51b5",
          "& .MuiTypography-root": {
            color: "white",
          },
        },
      },
    },
    // * tabs allow switching between day and time
    MuiDateTimePickerTabs: {
      styleOverrides: {
        root: {
          backgroundColor: "#3f51b5",
        },
      },
    },
  },
});

const DateSold = (props) => {
  // TODO: add the validation for the DatePicker
  return (
    <Box mt={0} width="100%" align="center">
      <h2 className="sectionTitle center">Date Sold</h2>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12} md="auto">
          <Box m={2}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className="form-input"
              size="large"
              onClick={(e) => props.DateSoldNowHandler(e)}
              key={"date_sold_now"}
              startIcon={<TodayIcon />}
            >
              {"Today"}
            </Button>
          </Box>
        </Grid>
        <Grid item xs={12} md="auto">
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <MobileDatePicker
                  label="Date Sold"
                  className="sold_date"
                  name="date_sold"
                  value={
                    props.display_date_sold ? props.display_date_sold : null
                  }
                  onChange={(date) => props.dateSoldHandler(date)}
                  ampm={false}
                  inputFormat={"MM-DD-YYYY"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      helperText={getHelpText(props.helpText, "date_sold")}
                    />
                  )}
                  maxDate={getMaxDate().format("MM-DD-YYYY")}
                  minDate={getMinDate().format("MM-DD-YYYY")}
                />
              </LocalizationProvider>
            </ThemeProvider>
          </StyledEngineProvider>
          <HelpText helpText={getHelpText(props.helpText, "date_sold")} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default DateSold;
